import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { Popover, Transition, Menu } from "@headlessui/react";
import { Link, useHistory } from "react-router-dom";

import {
  MenuIcon,
  XIcon,
  LightningBoltIcon,
  SearchIcon,
} from "@heroicons/react/outline";
import { useAuth } from "../context/AuthContext";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const { currentUser, logout } = useAuth();
  const [role, setRole] = useState("Member");
  const [pagehide, setPageHide] = useState(false);
  const history = useHistory();

  useEffect(() => {
    let user = JSON.parse(sessionStorage.getItem("authUser"));

    if (user === null) {
      setRole("Member");
      setPageHide(false);
    } else {
      if (user.hasOwnProperty("invites")) {
        setRole("Mentor");
        setPageHide(true);
      } else {
        setRole("Member");
        setPageHide(false);
      }
    }
  }, [currentUser]);

  const solutions = [
    {
      name: "Find a Mentor",
      description:
        "Get a better understanding of where your traffic is coming from.",
      href: "/mentors",
      icon: SearchIcon,
      show: true,
    },
    {
      name: "Become a Mentor",
      description:
        "Build strategic funnels that will drive your customers to convert",
      href: "/become-mentor",
      icon: LightningBoltIcon,
      show: !pagehide,
    },
  ];

  async function handleLogout() {
    try {
      await logout();
      sessionStorage.removeItem("authUser");
      sessionStorage.removeItem("public");
      history.push("/");
      toast.success("Logged out");
    } catch {}
  }

  const onDashboard = () => {
    let user = JSON.parse(sessionStorage.getItem("authUser"));

    if (user === null) {
      history.push("/getting-started");
      let isRegistered = {
        registered: false,
      };
      sessionStorage.setItem("isRegistered", JSON.stringify(isRegistered));
    } else {
      if (user.hasOwnProperty("invites")) {
        setRole("Mentor");
        history.push("/mentor/dashboard");
      } else {
        history.push("/member/dashboard");
        setRole("Member");
      }
    }
  };

  return !currentUser || currentUser.displayName === null ? (
    <>
      <Popover className="relative bg-white">
        {({ open }) => (
          <>
            <div className="container  mx-auto px-4 sm:px-2 ">
              <div className="flex justify-between items-center border-b-2 border-gray-100 py-6 sm:py-4 md:justify-start  md:space-x-10">
                <div className="flex justify-start lg:w-0 lg:flex-1">
                  <Link to="/">
                    <div className="w-max flex items-center">
                      <div>
                        <div
                          className="
                    flex
                    title-font
                    font-medium
                    items-center
                    md:justify-start
                    justify-center
                    text-gray-900
                  "
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 64 64"
                            fill="none"
                            className="w-7 h-7"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <circle cx="32" cy="32" r="21.3333" fill="white" />
                            <path
                              fillRule="evenodd"
                              clipRule="evenodd"
                              d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                              fill="url(#paint0_linear)"
                            />
                            <defs>
                              <linearGradient
                                id="paint0_linear"
                                x1="-5.90224e-07"
                                y1="-2.61818"
                                x2="52.6545"
                                y2="61.3818"
                                gradientUnits="userSpaceOnUse"
                              >
                                <stop stopColor="#3D98FF" />
                                <stop offset="1" stopColor="#330B66" />
                              </linearGradient>
                            </defs>
                          </svg>
                        </div>
                      </div>
                      <div className="sm:text-3xl text-2xl font-bold text-gray-900 ml-4">
                        Dev Colony
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="-mr-2 -my-2 md:hidden">
                  <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Open menu</span>
                    <MenuIcon className="h-6 w-6" aria-hidden="true" />
                  </Popover.Button>
                </div>
                <div className="hidden md:flex items-center justify-end md:flex-1 lg:w-0">
                  <div className="hidden md:flex space-x-10">
                    <Link
                      to="/become-mentor"
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Become a mentor
                    </Link>
                    <Link
                      to="/mentors"
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Find a mentor
                    </Link>
                  </div>
                  <Link
                    to="/login"
                    className="ml-6 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-blue-600 rounded-md  bg-gradient-to-r from-blue-500 to-blue-900 text-transparent bg-clip-text font-medium"
                  >
                    Login
                  </Link>
                  <Link
                    to="/signup"
                    className="ml-2 whitespace-nowrap inline-flex items-center justify-center px-4 py-2 border border-transparent rounded-md text-base font-medium text-white bg-gradient-to-r from-blue-500 to-blue-900"
                  >
                    Sign up
                  </Link>
                </div>
              </div>
            </div>

            <Transition
              show={open}
              as={Fragment}
              enter="duration-200 ease-out"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="duration-100 ease-in"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Popover.Panel
                focus
                static
                className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-10"
              >
                <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                  <div className="pt-5 pb-6 px-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <Link to="/">
                          <div className="w-max flex items-center">
                            <div>
                              <div
                                className="
                    flex
                    title-font
                    font-medium
                    items-center
                    md:justify-start
                    justify-center
                    text-gray-900
                  "
                              >
                                <svg
                                  width="24"
                                  height="24"
                                  viewBox="0 0 64 64"
                                  fill="none"
                                  className="w-7 h-7"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <circle
                                    cx="32"
                                    cy="32"
                                    r="21.3333"
                                    fill="white"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                                    fill="url(#paint0_linear)"
                                  />
                                  <defs>
                                    <linearGradient
                                      id="paint0_linear"
                                      x1="-5.90224e-07"
                                      y1="-2.61818"
                                      x2="52.6545"
                                      y2="61.3818"
                                      gradientUnits="userSpaceOnUse"
                                    >
                                      <stop stopColor="#3D98FF" />
                                      <stop offset="1" stopColor="#330B66" />
                                    </linearGradient>
                                  </defs>
                                </svg>
                              </div>
                            </div>
                            <div className="sm:text-3xl text-2xl font-bold text-gray-900 ml-4">
                              Dev Colony
                            </div>
                          </div>
                        </Link>
                      </div>
                      <div className="-mr-2">
                        <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                          <span className="sr-only">Close menu</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                      </div>
                    </div>
                    <div className="mt-8">
                      <nav className="grid gap-y-8">
                        {solutions.map((item) => (
                          <a
                            key={item.name}
                            href={item.href}
                            className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                          >
                            <item.icon
                              className="flex-shrink-0 h-6 w-6 text-blue-700"
                              aria-hidden="true"
                            />
                            <span className="ml-3 text-base font-medium text-gray-900">
                              {item.name}
                            </span>
                          </a>
                        ))}
                      </nav>
                    </div>
                  </div>
                  <div className="py-6 px-5 space-y-6">
                    <div>
                      <Link
                        to="/signup"
                        className="w-full flex items-center -mt-4 justify-center px-4 py-2 border border-transparent rounded-md shadow-sm text-base font-medium text-white  bg-gradient-to-r from-blue-500 to-blue-900"
                      >
                        Sign up
                      </Link>
                      <p className="mt-6 text-center text-base font-medium text-gray-500">
                        Have an account?{" "}
                        <Link
                          to="/login"
                          className="text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-blue-900"
                        >
                          Login
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
            <ToastContainer
              position="top-right"
              autoClose={5000}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </>
        )}
      </Popover>
    </>
  ) : (
    <>
      <Popover as="nav" className="relative bg-white">
        {({ open }) => (
          <>
            <div className="container  mx-auto px-4 sm:px-2 ">
              <div className="relative flex items-center justify-between py-6 sm:py-4 border-b-2 border-gray-100">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button*/}
                  <Popover.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Popover.Button>
                </div>
                <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                  <div className="flex-shrink-0 flex items-center">
                    <Link to="/">
                      <div className="w-max flex items-center">
                        <div>
                          <div
                            className="
                    flex
                    title-font
                    font-medium
                    items-center
                    md:justify-start
                    justify-center
                    text-gray-900
                  "
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 64 64"
                              fill="none"
                              className="w-7 h-7"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle
                                cx="32"
                                cy="32"
                                r="21.3333"
                                fill="white"
                              />
                              <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                                fill="url(#paint0_linear)"
                              />
                              <defs>
                                <linearGradient
                                  id="paint0_linear"
                                  x1="-5.90224e-07"
                                  y1="-2.61818"
                                  x2="52.6545"
                                  y2="61.3818"
                                  gradientUnits="userSpaceOnUse"
                                >
                                  <stop stopColor="#3D98FF" />
                                  <stop offset="1" stopColor="#330B66" />
                                </linearGradient>
                              </defs>
                            </svg>
                          </div>
                        </div>
                        <div className="sm:text-3xl text-2xl font-bold text-gray-900 ml-4">
                          Dev Colony
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                  {/* <button className="bg-gray-200 p-1 rounded-full text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white">
                  <span className="sr-only">View notifications</span>
                  <BellIcon className="h-6 w-6" aria-hidden="true" />
                </button> */}

                  <div className="hidden md:flex space-x-10 mr-6">
                    {!pagehide && (
                      <Link
                        to="/become-mentor"
                        className="text-base font-medium text-gray-500 hover:text-gray-900"
                      >
                        Become a mentor
                      </Link>
                    )}
                    <Link
                      to="/mentors"
                      className="text-base font-medium text-gray-500 hover:text-gray-900"
                    >
                      Find a mentor
                    </Link>
                  </div>

                  {/* Profile dropdown */}
                  <Menu as="div" className="ml-3 relative">
                    {({ open }) => (
                      <>
                        <div>
                          <Menu.Button className="bg-blue-400 flex text-sm rounded-full border-2 border-blue-300">
                            <span className="sr-only">Open user menu</span>
                            <div>
                              {currentUser.photoURL ? (
                                <img
                                  className="h-8 w-8 rounded-full"
                                  src={currentUser.photoURL}
                                  alt={currentUser.displayName}
                                />
                              ) : (
                                <div className="h-8 w-8 rounded-full bg-blue-200 pt-0.5 font-bold text-xl">
                                  <p className=" bg-gradient-to-r from-blue-500 to-blue-900 text-transparent bg-clip-text">
                                    {currentUser.displayName[0].toUpperCase()}
                                  </p>
                                </div>
                              )}
                            </div>
                          </Menu.Button>
                        </div>
                        <Transition
                          show={open}
                          as={Fragment}
                          enter="transition ease-out duration-100"
                          enterFrom="transform opacity-0 scale-95"
                          enterTo="transform opacity-100 scale-100"
                          leave="transition ease-in duration-75"
                          leaveFrom="transform opacity-100 scale-100"
                          leaveTo="transform opacity-0 scale-95"
                        >
                          <Menu.Items
                            static
                            className="origin-top-right absolute right-0 mt-2 w-60 rounded-md shadow-lg  bg-white ring-1 ring-black ring-opacity-5 focus:outline-none z-10"
                          >
                            <Menu.Item>
                              {({ active }) => (
                                <>
                                  <div className="px-4 py-3">
                                    <div className="w-max flex items-center">
                                      <div>
                                        {currentUser.photoURL ? (
                                          <img
                                            className="h-12 w-12 rounded-full"
                                            src={currentUser.photoURL}
                                            alt={currentUser.displayName}
                                          />
                                        ) : (
                                          <div className="h-12 w-12 rounded-full bg-blue-200 pl-4 pt-2 font-bold text-2xl">
                                            <p className=" bg-gradient-to-r from-blue-500 to-blue-900 text-transparent bg-clip-text">
                                              {currentUser.displayName[0].toUpperCase()}
                                            </p>
                                          </div>
                                        )}
                                      </div>
                                      <div className="sm:text-3xl text-2xl  text-gray-900 ml-4">
                                        <p className="text-lg font-semibold leading-5 truncate">
                                          {currentUser.displayName}
                                        </p>
                                        <p className="text-sm  leading-5 text-gray-900 truncate text-blue-700">
                                          {role}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="border border-gray-100"></div>
                                  <p
                                    onClick={onDashboard}
                                    className={classNames(
                                      active ? "bg-gray-100" : "",
                                      "block px-4 py-2 text-sm text-gray-700"
                                    )}
                                  >
                                    Your Account
                                  </p>
                                </>
                              )}
                            </Menu.Item>
                            <Menu.Item>
                              {({ active }) => (
                                <p
                                  onClick={handleLogout}
                                  className={classNames(
                                    active ? "bg-gray-100" : "",
                                    "block px-4 py-2 text-sm text-gray-700"
                                  )}
                                >
                                  Sign out
                                </p>
                              )}
                            </Menu.Item>
                          </Menu.Items>
                        </Transition>
                      </>
                    )}
                  </Menu>
                </div>
              </div>
            </div>

            <Transition
              show={open}
              as={Fragment}
              enter="duration-200 ease-out"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="duration-100 ease-in"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Popover.Panel
                focus
                static
                className="absolute top-0 inset-x-0 p-2 transition transform origin-top-right md:hidden z-10"
              >
                <div className="rounded-lg shadow-lg ring-1 ring-black ring-opacity-5 bg-white divide-y-2 divide-gray-50">
                  <div className="pt-5 pb-6 px-5">
                    <div className="flex items-center justify-between">
                      <div>
                        <div className="w-max flex items-center">
                          <div>
                            <a
                              className="
                    flex
                    title-font
                    font-medium
                    items-center
                    md:justify-start
                    justify-center
                    text-gray-900
                  "
                              href="/"
                            >
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 64 64"
                                fill="none"
                                className="w-7 h-7"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle
                                  cx="32"
                                  cy="32"
                                  r="21.3333"
                                  fill="white"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M7.52941 0C3.37103 0 0 3.37103 0 7.52941V56.4706C0 60.629 3.37103 64 7.52941 64H32C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0H7.52941ZM31.3172 23.377C34.0962 20.5435 38.51 20.0531 41.5069 22.6142C44.9398 25.5567 45.1033 30.7877 42.0518 33.9482L31.4807 44.8463C30.8268 45.5547 29.6825 45.5547 29.0286 44.8463L18.4575 33.9482C15.406 30.7877 15.5695 25.5567 19.0024 22.6142C21.9993 20.0531 26.4676 20.5435 29.1921 23.377L30.2819 24.4668L31.3172 23.377Z"
                                  fill="url(#paint0_linear)"
                                />
                                <defs>
                                  <linearGradient
                                    id="paint0_linear"
                                    x1="-5.90224e-07"
                                    y1="-2.61818"
                                    x2="52.6545"
                                    y2="61.3818"
                                    gradientUnits="userSpaceOnUse"
                                  >
                                    <stop stopColor="#3D98FF" />
                                    <stop offset="1" stopColor="#330B66" />
                                  </linearGradient>
                                </defs>
                              </svg>
                            </a>
                          </div>
                          <div className="sm:text-3xl text-2xl font-bold text-gray-900 ml-4">
                            Dev Colony
                          </div>
                        </div>
                      </div>
                      <div className="-mr-2">
                        <Popover.Button className="bg-white rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                          <span className="sr-only">Close menu</span>
                          <XIcon className="h-6 w-6" aria-hidden="true" />
                        </Popover.Button>
                      </div>
                    </div>
                    <div className="mt-8">
                      <nav className="grid gap-y-8">
                        {solutions.map((item) =>
                          item.show ? (
                            <a
                              key={item.name}
                              href={item.href}
                              className="-m-3 p-3 flex items-center rounded-md hover:bg-gray-50"
                            >
                              <item.icon
                                className="flex-shrink-0 h-6 w-6 text-blue-700"
                                aria-hidden="true"
                              />
                              <span className="ml-3 text-base font-medium text-gray-900">
                                {item.name}
                              </span>
                            </a>
                          ) : (
                            ""
                          )
                        )}
                      </nav>
                    </div>
                  </div>
                </div>
              </Popover.Panel>
            </Transition>
          </>
        )}
      </Popover>
    </>
  );
}
